<template>
  <div class="cols-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="尺寸" name="1">
        <div class="content">
          <div class="verticallyCenter">
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8 color000">宽</span>
              <el-input type="number" value="-" disabled style="width: 100%" v-model="showWidthVal">
                <template slot="suffix">
                  <span class="suffix_text">%</span>
                </template>
              </el-input>
            </div>
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <single-input style="width: 100%" :value.sync="showHeightVal" inputSuffixs="%" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-if="checkShowTabs('排列') && !disableSetColAndRow" title="排列" name="2">
        <div class="content">
          <div class="content-item mb16" v-if="!showRowColLayout">
            <emptyLayoutComponent />
          </div>
          <!--          反馈，说有bug，修复后放开-->
          <!--                    <autoLayoutSetting-->
          <!--                      :options="activeCol.componentBoxOptions"-->
          <!--                      :elementOptions="activeCol.elementOptions"-->
          <!--                      :ids="ids"-->
          <!--                      @update="handleSet"-->
          <!--                    />-->
          <rowColLayoutSetting v-if="showRowColLayout" :options="activeCol.componentBoxOptions" :ids="ids" @update="handleSet"/>
        </div>
      </el-collapse-item>
      <el-collapse-item title="背景" name="3">
        <backGroundSetting
          infoTips="支持上传图片"
          :options="activeCol.componentBoxOptions"
          :ids="ids"
          @update="handleSet"
        />
      </el-collapse-item>
      <el-collapse-item title="边框" name="4">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
            <el-tooltip
              popper-class="width200"
              effect="dark"
              content="边框颜色为线性渐变或径向渐变时：背景颜色的透明度必须为1。此时背景模糊不生效；虚线、点线不生效。"
              placement="top"
              :open-delay="1000"
            >
              <span class="tips-btn icon-portal-info2"></span>
            </el-tooltip>
          </div>
          <borderSetting
            v-if="showBorder"
            ref="borderSetting"
            :options="activeCol.componentBoxOptions"
            :ids="ids"
            @update="handleSet"
          />
        </div>
        <div class="content-item mt16">
          <radiusSetting :options="activeCol.componentBoxOptions" :ids="ids" @update="handleSet" />
        </div>
      </el-collapse-item>
      <el-collapse-item v-if="checkShowTabs('边距')" title="边距" name="5">
        <paddingSetting
          :options="activeCol.componentBoxOptions"
          :isLastCol="activeCol.rows ? false : true"
          :ids="ids"
          @update="handleSet"
        />
      </el-collapse-item>
      <el-collapse-item v-if="checkShowTabs('外观')" title="更多" name="6">
        <div>
          <!-- 暂时屏蔽单元格的透明度，禁止删除！！！！ -->
          <div class="content-item" style="display: none">
            <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
          </div>
          <div class="setting-item">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="boxShadowH"
              :boxShadowV.sync="boxShadowV"
              :boxShadowBlur.sync="boxShadowBlur"
              :boxShadowSpread.sync="boxShadowSpread"
              :boxShadowColor.sync="boxShadowColor"
            />
          </div>
          <div class="content-item mt16">
            <public-style :options="activeCol" :ids="ids"></public-style>
          </div>
          <div class="content-item mt16 cx_style" style="line-height: 18px">
            <el-checkbox v-model="showCropping">裁剪内容</el-checkbox>
            <span class="third-text">(仅预览页生效)</span>
            <i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
          </div>
          <div class="content-item verticallyBetweenCenter mt12">
            <span class="verticallyCenter">布局模式<i class="tips-btn icon-portal-info2" @click="explainAutoDialog = true"></i></span>
            <el-select v-model="autoLayoutType" style="width: 120px;">
              <el-option v-for="(item, index) in layoutTypeList" :key="index" :label="item.label" :value="item.value">
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        勾选裁剪内容后，任何溢出容器的内容都将被隐藏，不会显示在容器的边界之外。<span>仅在预览页生效</span>
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
      </div>
    </el-dialog>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainAutoDialog" custom-class="explainDialog">
      <div class="auto-layout-body">
      <p class="fs14 tips">
        <span>排列模式：</span>
      </p>
      <ul>
        <li>开启排列模式后，布局内部元素会按照一定方向排列，配合行布局组件可以实现均匀的排列效果</li>
      </ul>
      <p class="fs14 tips">
        <span>功能说明：</span>
      </p>
      <p>
        通常情况下，一个网页的元素是遵从一定的顺序进行排列，例如2张图片横向排列，第3张以及后续图片都希望自动往左侧填充，超过宽度则自动换行，不仅可以减少整理页面的时间还可以实现更灵活的自适应效果。可以理解「自动布局」是为了简化原生页面使用Flex属性，并且达到类似的效果，你可以做到：
      </p>
      <ul>
        <li>让按钮或卡片随文本增减而自动调整尺寸</li>
        <li>将列表快速重新排序</li>
        <li>实现更多更复杂元素的全自动排布</li>
      </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import radiusSetting from "./setting/radiusSetting.vue"
import backGroundSetting from "./setting/backGroundSetting.vue"
import borderSetting from "./setting/borderSetting.vue"
import paddingSetting from "./setting/paddingSetting.vue"
import autoLayoutSetting from "./setting/autoLayoutSetting.vue"
import emptyLayoutComponent from "../emptyLayoutComponent/emptyLayoutComponent.vue"
import {
  handleFindLayoutComponentOptionsCols,
  handleFindLayoutComponentColsParentRowByUid,
  isEqual
} from "../../../utils"
import { withMethodsHistoryCombine, historyCombineWrap } from "utils/revork"
import { CATEGORY_MODE } from "@/consts"
import rowColLayoutSetting from "../../../materials/autoLayout/toolbars/setting/rowColLayoutSetting.vue"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  components: {
    emptyLayoutComponent,
    paddingSetting,
    radiusSetting,
    borderSetting,
    backGroundSetting,
    autoLayoutSetting,
    rowColLayoutSetting,
    publicStyle
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      this1: this,
      idChange: false,
      explainDialog: false,
      explainAutoDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/cropping-img.png"),
      layoutTypeList: [
        {
          label: "自由拖拽",
          value: "free"
        },{
          label: "纵向排列",
          value: "vertical"
        },{
          label: "横向排列",
          value: "horizon"
        },
      ]
    }
  },
  watch: {
    ids: {
      handler() {
        this.idChange = true
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    showColsSetting() {
      if (!this.options) return false
      if (this.options.hasOwnProperty("showColsSetting") === false) return true
      return this.options.showColsSetting
    },
    activeCol() {
      const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
      const pOptions = [this.getOptions.rows[useActiveIndex]]
      // 如果这个节点已经被删除了，直接找根节点，避免空对象
      return (
        handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid) ||
        handleFindLayoutComponentOptionsCols(pOptions, pOptions[0].cols[0].uid)
      )
    },
    disableSetColAndRow() {
      return this.hasProperty(this.options, "disableSetColAndRow")
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowColor", "boxShadowColor", [
          "rgba(255,255,255,1)"
        ])
      },
      set(newVal) {
        this.handleSet("boxShadowColor", newVal)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowH", newVal)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowV", newVal)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowBlur", newVal)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowSpread", newVal)
      }
    },
    getOptions: function () {
      if (this.getRectAttribute.call(this, this.ids).shape === "cxAutoLayout") {
        return this.getAttrById(this.$store.state[this.request_prefix], this.ids, "elementInAutoLayout")
      }
      return this.getRectAttribute.call(this, this.ids).options
    },
    showWidthVal: {
      get() {
        return Math.floor(this.width)
      },
      set(newVal) {
        this.width = newVal
      }
    },
    showHeightVal: {
      get() {
        return Math.floor(this.height)
      },
      set(newVal) {
        this.height = newVal
      }
    },
    width: {
      get() {
        return parseFloat(this.activeCol.width)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "width", false)
      }
    },
    height: {
      get() {
        const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        const pOptions = [this.getOptions.rows[useActiveIndex]]
        // 查找当前选中col的父级row
        let result = handleFindLayoutComponentColsParentRowByUid(pOptions, this.activeCol.uid)
        return result?.height?.slice(0, -1)
      },
      set(newVal) {
        const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        const pOptions = [this.getOptions.rows[useActiveIndex]]
        let row = handleFindLayoutComponentColsParentRowByUid(pOptions, this.activeCol.uid)
        this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          type: "height",
          row: row,
          val: newVal + "%"
        })
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.handleSet("opacity", newVal)
      }
    },
    // 是否裁剪内容
    showCropping: {
      get() {
        return this.activeCol.componentBoxOptions.hasOwnProperty("showCropping") ? this.activeCol.componentBoxOptions.showCropping : false
      },
      set(newVal) {
        this.handleSet("showCropping", newVal)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if(this.activeCol.componentBoxOptions.showBorder === undefined){
          if(this.activeCol.componentBoxOptions.borderWidth){
            showBorder = true
          }else{
            showBorder = false
          }
        }else{
          showBorder = this.activeCol.componentBoxOptions.showBorder
        }
        return showBorder
      },
      set(newVal) {
        historyCombineWrap(() => {
          if(newVal && !this.activeCol.componentBoxOptions.borderWidth) {
            this.handleSet("borderWidth", 1)
          }
          this.handleSet("showBorder", newVal)
        })()
      }
    },
    showRowColLayout: {
      get() {
        const componentBoxOptions = this.options?.componentBoxOptions
        return componentBoxOptions.hasOwnProperty("showRowColLayout") ? componentBoxOptions.showRowColLayout : false
      },
      set(newVal) {
        this.handleSet("showRowColLayout", newVal)
      }
    },
    autoLayoutType: {
      get() {
        const componentBoxOptions = this.options?.componentBoxOptions
        if (this.showRowColLayout) {
          return componentBoxOptions.rowColDirection || "vertical"
        } else {
          return "free"
        }
      },
      set(newVal) {
        if (newVal === "free") this.showRowColLayout = false
        else {
          this.showRowColLayout = true
          this.handleSet("rowColDirection", newVal)
        }
      }
    }
  },
  methods: {
    addBoxshadow() {
      if(!Array.isArray(this.boxShadowH)){
        this.boxShadowH = [this.boxShadowH]
      }
      if(!Array.isArray(this.boxShadowV)){
        this.boxShadowV = [this.boxShadowV]
    }
      if(!Array.isArray(this.boxShadowBlur)){
        this.boxShadowBlur = [this.boxShadowBlur]
      }
      if(!Array.isArray(this.boxShadowColor)){
        this.boxShadowColor = [this.boxShadowColor]
      }
      if(!Array.isArray(this.boxShadowSpread)){
        this.boxShadowSpread = [this.boxShadowSpread]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    checkShowTabs(name) {
      if (typeof this.showColsSetting === "boolean") return this.showColsSetting
      return !!this.showColsSetting.find(it => it === name)
    },
    handleSet(key, val) {
      if (this.activeCol.componentBoxOptions[key] === val && typeof val !== "object") return
      this.$changeOptionsEV(val, key, false, null, this.ids)
    }
  }
})
</script>

<style scoped>
  .third-text {
    color: var(--thirdTextColor);
  }
</style>
